<template>
  <div>
    <my-head></my-head>
    <div class="deal minH">
      <div class="crumbs">
        首页 >
        <span style="color: #1d2129">成交公告</span>
      </div>
      <!-- tab切换 -->
      <el-tabs v-model="activeName">
        <el-tab-pane label="专利" name="专利"></el-tab-pane>
        <el-tab-pane label="商业秘密" name="商业秘密"></el-tab-pane>
        <el-tab-pane label="商标" name="商标"></el-tab-pane>
        <el-tab-pane label="版权" name="版权"></el-tab-pane>
        <el-tab-pane label="集成电路" name="集成电路"></el-tab-pane>
        <el-tab-pane label="其他" name="其他"></el-tab-pane>
      </el-tabs>
      <!-- 搜索框 -->
      <div class="flex-left-center sou_suo">
        <input type="text" v-model="ssInput" placeholder="请输入项目名称">
        <img src="../../assets/search.png" alt="" @click="souSuo">
        <div class="ss_but flex-center"  @click="souSuo">搜索</div>
      </div>
      <!-- 列表 -->
      <div class="list">
        <router-link v-for="(item, index) in list" :key="index" :to="`/deal/details?id=${item.id}`">
          <deal-col class="col" :cData="item"></deal-col>
        </router-link>
      </div>
      <!-- 分页 -->
      <div class="flex-center fen_ye">
        <el-pagination background :current-page.sync="page.page" :page-size="page.size" layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../../components/MyHead.vue";
import MyFooter from "../../components/MyFooter.vue";
import DealCol from "../../components/DealCol.vue";
import { getRequest, postRequest } from "../../api/api";
import { mapPropertyCategoryForRequest } from "../../api/util";
export default {
  components: { MyHead, MyFooter, DealCol },
  data() {
    return {
      activeName: "专利",
      page: {
        page: 1,
        size: 10,
      },
      total: 0,
      list: [],
      ssInput: '',
    };
  },
  watch: {
    page: {
      handler() {
        this.getList();
      },
      deep: true,
    },
    activeName() {
      this.getList();
    },
  },
  methods: {
    souSuo() {
      this.page.page = 1
      this.getList()
    },
    getList() {
      let data = {
        ...this.page,
        propertyCategory: mapPropertyCategoryForRequest(this.activeName),
        search: this.ssInput,
      };
      getRequest({ url: "/api/v1/done/page", data }).then((res) => {
        if (res.errcode == 200) {
          this.list = res.data;
          this.total = res.totalCount;
        }
      });
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="scss">
.deal {
  width: 80%;
  margin: 24px auto 60px;

  .sou_suo {
    margin-bottom: 20px;
    position: relative;

    .ss_but{
      height: 30px;
      color: #ffffff;
      background: #409EFF;
      padding: 0 12px;
      margin-left: 12px;
      border-radius: 2px;
      cursor: pointer;
    }

    img {
      height: 24px;
      position: absolute;
      left: 5px;
      top: 50%;
      margin-top: -12px;
      cursor: pointer;
    }

    input {
      border: none;
      background: #eeeeee;
      height: 30px;
      border-radius: 15px;
      outline: none;
      padding: 0 24px 0 34px;
      width: 600px;
    }


    // button {
    //   border: #cccccc solid 2px;
    //   padding: 0 12px;
    //   border-left: none;
    // }
  }

  .col {
    margin-bottom: 20px;
  }

  .fen_ye {
    margin-top: 48px;
  }

  .el-tabs__item {
    font-size: 18px;
    height: 50px;
    line-height: 50px;
  }
}
</style>
